import { buildQueryParams } from 'libs/utils'

import { trackHighlight } from './events'

export const name = 'twitter'

const CHAR_LIMIT = 120

export const getText = (text) => {
  let chunk = text.trim()

  if (chunk.length > CHAR_LIMIT - 2) {
    chunk = `${chunk.slice(0, CHAR_LIMIT - 3).trim()}\u2026`
  }

  return `\u201c${chunk}\u201d\n`
}

export const getShareUrl = (text, refUrl) => {
  const params = [
    ['source', 'webclient'],
    ['via', 'masterclass'],
    ['text', text],
    ['url', `${refUrl.origin}${refUrl.pathname}`],
  ]

  return `https://twitter.com/intent/tweet?${buildQueryParams(params)}`
}

export const action = () => trackHighlight('share-highlight-twitter')

export const render = (text, rawText, refUrl) => {
  const shareText = getText(text)
  const url = getShareUrl(shareText, refUrl)

  return `
    <a href="${url}" target="_blank" rel="noopener nofollow noreferrer">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.2883 24.129C19.8323 24.129 23.9603 17.873 23.9603 12.457C23.9603 12.281 23.9603
        12.105 23.9523 11.929C24.7523 11.353 25.4483 10.625 26.0003 9.80105C25.2643 10.129 24.4723 10.345
        23.6403 10.449C24.4883 9.94505 25.1363 9.13705 25.4483 8.17705C24.6563 8.64905 23.7763 8.98505
        22.8403 9.16905C22.0883 8.36905 21.0243 7.87305 19.8483 7.87305C17.5843 7.87305 15.7443 9.71305
        15.7443 11.977C15.7443 12.297 15.7843 12.609 15.8483 12.913C12.4403 12.745 9.4163 11.105 7.3923
        8.62505C7.0403 9.23305 6.8403 9.93705 6.8403 10.689C6.8403 12.113 7.5683 13.369 8.6643 14.105C7.9923
        14.081 7.3603 13.897 6.8083 13.593C6.8083 13.609 6.8083 13.625 6.8083 13.649C6.8083 15.633 8.2243
        17.297 10.0963 17.673C9.7523 17.769 9.3923 17.817 9.0163 17.817C8.7523 17.817 8.4963 17.793 8.2483
        17.745C8.7683 19.377 10.2883 20.561 12.0803 20.593C10.6723 21.697 8.9043 22.353 6.9843 22.353C6.6563
        22.353 6.3283 22.337 6.0083 22.297C7.8163 23.449 9.9763 24.129 12.2883 24.129Z" fill="white"/>
      </svg>
    </a>
  `
}
